import React from 'react';
import { RicosViewerLazy } from '../../loadable';
import styles from './field-description-wut.scss';
const RICOS_THEME = {
  customStyles: {
    p: {
      fontSize: 'var(--wix-forms-formInputNoteFont-size)',
      fontFamily: 'var(--wix-forms-formInputNoteFont-family)',
      color: 'rgb(var(--wix-forms-formInputNoteColor))'
    }
  }
};
export const FieldDescriptionWUT = _ref => {
  let {
    description,
    id
  } = _ref;
  return description ? /*#__PURE__*/React.createElement("div", {
    className: styles.description,
    "aria-hidden": "true",
    id: id
  }, /*#__PURE__*/React.createElement(RicosViewerLazy, {
    content: description,
    customTheme: RICOS_THEME
  })) : null;
};
//# sourceMappingURL=field-description-wut.js.map